__turbopack_context__.v({
  "address": "styles-module__3_2yEG__address",
  "archiveButton": "styles-module__3_2yEG__archiveButton",
  "badge": "styles-module__3_2yEG__badge",
  "deleteButton": "styles-module__3_2yEG__deleteButton",
  "description": "styles-module__3_2yEG__description",
  "editButton": "styles-module__3_2yEG__editButton",
  "icon": "styles-module__3_2yEG__icon",
  "iconButtonsContainer": "styles-module__3_2yEG__iconButtonsContainer",
  "morePhotosOverlay": "styles-module__3_2yEG__morePhotosOverlay",
  "price": "styles-module__3_2yEG__price",
  "profileObjectItem": "styles-module__3_2yEG__profileObjectItem",
  "profileObjectItemAction": "styles-module__3_2yEG__profileObjectItemAction",
  "profileObjectItemContent": "styles-module__3_2yEG__profileObjectItemContent",
  "profileObjectItemCounter": "styles-module__3_2yEG__profileObjectItemCounter",
  "profileObjectItemDD": "styles-module__3_2yEG__profileObjectItemDD",
  "profileObjectItemFooter": "styles-module__3_2yEG__profileObjectItemFooter",
  "profileObjectItemImage": "styles-module__3_2yEG__profileObjectItemImage",
  "rm": "styles-module__3_2yEG__rm",
  "thumbnailWrapper": "styles-module__3_2yEG__thumbnailWrapper",
  "title": "styles-module__3_2yEG__title",
});
